import api from "../../services/api";
import store from "..";

import types from "./types";
import { ActionType } from "../../models/types";
import { recordsLogged } from "../../models/interfaces";

const baseUrl = process.env.REACT_APP_PROVIDERDOCUMENT;

const setToken = (data: any): ActionType => ({
  type: types.SET_TOKEN,
  payload: data,
});

const setAuthType = (data: any): ActionType => ({
  type: types.SET_AUTH_TYPE,
  payload: data,
});

const setPageTitle = (data: any): ActionType => ({
  type: types.SET_PAGE_TITLE,
  payload: data,
});

const setLoading = (data: any): ActionType => ({
  type: types.SET_LOADING_TOKEN,
  payload: data,
});

// export const getAuth = async (resetToken = false) => {
//   store.dispatch(setLoading(true));

//   const params = {
//     id: 4,
//     cnpj:  34,
//   }

//   const storageToken = localStorage.getItem('token');

//   try {
//     if (!storageToken || resetToken) {
//       const { data } = await api.get(`/auth?id=${params.id}&username=${params.cnpj}`);
//       if (data) {
//         localStorage.setItem('token', data.token);
//         store.dispatch(setToken(data.token));
//       }
//     } else {
//       store.dispatch(setToken(storageToken));
//     }
//     getAuthType();
//   }
//   catch (err) {
//     console.log(err);
//   }
//   finally {
//     store.dispatch(setLoading(false));
//   }
// }

export const getAuth = async (token: string) => {
  store.dispatch(setLoading(true));

  localStorage.setItem("token", token);
  store.dispatch(setToken(token));

  store.dispatch(setLoading(false));

  return getAuthType();
};

const getAuthType = async () => {
  store.dispatch(setLoading(true));

  try {
    const {
      data: { data },
    } = await api.get(baseUrl + "/records/logged");
    const records: recordsLogged = data.records;

    if (records) {
      store.dispatch(setAuthType(records.type));
    }
    return true;
  } catch (err) {
    // if(err.response.status === 401) {
    //   getAuth(true);
    // }
    console.log(err);
    return false;
  }
};

export const checkPageTitle = (props: any) => {
  let url: string | undefined = props.location.pathname;
  let title: string = "";

  if (Boolean(url)) {
    const regex = /([A-z-/])/g;
    url = url?.match(regex)?.join("");
    url = url?.substring(
      1,
      url[url.length - 1] === "/" ? url.length - 1 : url.length
    );
    // if (url) {
    //   const posAfterToken = url?.search("/");
    //   url = url.substring(posAfterToken + 1, url?.length);
    // }

    switch (url) {
      case "document-type":
        title = "Tipos de Documento";
        break;
      case "document-type/create":
        title = "Criar Tipo de Documento";
        break;
      case "document-type/edit":
        title = "Editar Tipo de Documento";
        break;
      case "document-type/list":
        title = "Tipos de Documentos";
        break;

      case "document":
        title = "Documento";
        break;
      case "document/create":
        title = "Enviar Documento";
        break;
      case "document/edit":
        title = "Editar Documento";
        break;
      case "document/detail":
        title = "Visualizar Documento";
        break;
      case "document/list":
        title = "Meus Documentos";
        break;

      case "document//create":
        title = "Enviar Documento do Fornecedor";
        break;
      case "document//edit":
        title = "Editar Documento do Fornecedor";
        break;
      case "document//detail":
        title = "Visualizar Documento do Fornecedor";
        break;
      case "document//list":
        title = "Documentos do Fornecedor";
        break;
      case "document/all/list":
        title = "Todos os Documentos";
        break;

      case "product/relationship-date-import":
        title = "Importação Relação de Datas de Produtos";
        break;

      case "email/config":
        title = "Configuração de Email";
        break;
    }

    store.dispatch(setPageTitle(title));
  }
};
